export default __webpack_public_path__ + "static/media/new-campaign-2x.7c1c3e74.png";